module.exports = __webpack_public_path__ + "static/media/diveintowork_logo.790bd2d7.png";